import { Exception } from "./Exception";
import { ErrorSeverity } from "./ErrorSeverity";

export class InvalidComponentBlockException extends Exception {
  constructor() {
    super({
      errorSeverity: ErrorSeverity.ERROR,
      useErrorBoundary: true,
      name: "InvalidComponentBlockException",
      message: "Unknown session component block type",
      response: new Response(null, { status: 500 }),
    });
  }
}
